/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_RbacInputs */

const en_landing_chips_rbac = /** @type {(inputs: Landing_Chips_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const zh_landing_chips_rbac = /** @type {(inputs: Landing_Chips_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限管理`)
};

/**
* | output |
* | --- |
* | "RBAC" |
*
* @param {Landing_Chips_RbacInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_rbac = /** @type {((inputs?: Landing_Chips_RbacInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_RbacInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_rbac(inputs)
	return zh_landing_chips_rbac(inputs)
});
export { landing_chips_rbac as "landing.chips.rbac" }